import Heading from "src/Pages/Company/Dashboard/components/Heading";

const Widgets = () => <Heading />;

export default Widgets;
